export const selectGroupedOffers = ({ offersPage = {} }) => {
    // Extract sorted offers from state
    const { offers = {} } = offersPage;
    const { sortedOffers = [] } = offers;

    // Index offers
    return sortedOffers.reduce((offers, offer) => {
        const { amount, duration } = offer;

        // Index by amount
        offers[amount] = offers[amount] || {};

        // Further index by duration
        offers[amount][duration] = offer;

        return offers;
    }, {});
};

/**
 * Select the number of offers for each term
 * @param {*} State
 * @returns { [string]: number }
 */
export const selectTermCounts = ({ offersPage = {} }) => {
    // Extract sorted offers from state
    const { offers = {} } = offersPage;
    const { sortedOffers = [] } = offers;

    return sortedOffers.reduce((termCounts, offer) => {
        const { duration } = offer;

        if (termCounts[duration]) {
            termCounts[duration] += 1;
        } else {
            termCounts[duration] = 1;
        }

        return termCounts;
    }, {});
};

export default {
    selectGroupedOffers,
    selectTermCounts,
};
